import _maxBy from "lodash/maxBy";

import { createSelector } from "reselect";
import { selectHavainnotState } from "../selectors";
import { useSelector } from "react-redux";
import { useUsersAppRoleIdList } from "../../auth/store/authSelectors";
import { useMemo } from "react";
import { EPermissionLevel, ICategoryPermission } from "../../interfaces/ICategoryPermission";
import { isLoaded } from "../../../../sg-core";

const selectPermissionState = createSelector(selectHavainnotState, (state) => state.permissions);

export const selectCategoryPermissions = createSelector(
    selectPermissionState,
    (state) => state.categoryPermissions,
);

export const useCategoryPermission = (categoryId: number | false) => {
    const permissions = useSelector(selectCategoryPermissions);
    // const userRoles = useLoggedInUserRoles();
    const userRoles = useUsersAppRoleIdList();

    const roleIds = isLoaded(userRoles) ? userRoles.data : [];

    return useMemo(() => {
        if (isLoaded(permissions) && categoryId) {
            // const roleIds = userRoles.map((r) => r.id);

            const includePermission = (perm: ICategoryPermission) => {
                return perm.categoryId === categoryId && roleIds.includes(perm.roleId);
            };

            const categoryPerms = permissions.data.filter(includePermission);

            const getMaxPermission = (type: "read" | "edit" | "create") => {
                const maxPerm = _maxBy(categoryPerms, type);
                return maxPerm ? maxPerm[type] : EPermissionLevel.Never;
            };

            return {
                read: getMaxPermission("read"),
                edit: getMaxPermission("edit"),
                create: getMaxPermission("create"),
            };
        }
        return {
            read: EPermissionLevel.Never,
            edit: EPermissionLevel.Never,
            create: EPermissionLevel.Never,
        };
    }, [permissions, categoryId, roleIds]);
};
